export const createTransition = (event, check) => {
  return {
    event,
    check
  };
};